<script setup lang="ts">
import GesucheList from '@/views/auth/gesuch/GesucheList.vue'
import ProfileDialog from '@/components/complete-profile-first-dlg.vue'
import KpToolbar from '@/components/kp-toolbar.vue'
import { ref } from 'vue'
import { useAuthUser } from '@/helpers/globals'
import router from '@/router'
import { useRoute } from 'vuetify/lib/composables/router.mjs'

const currentItem = ref(null)
const showProfileDialog = ref(false)
function checkProfile() {
    if (useAuthUser()?.profileComplete()) {
        router.push({ name: 'gesuch_erstellen' })
    } else {
        showProfileDialog.value = true
    }
}
function closeProfileDialog() {
    showProfileDialog.value = false
}

const route = useRoute()
</script>

<template>
    <div v-if="route?.name === 'gesuche'">
        <KpToolbar :title="$t('gesuche')" icon="fas fa-balance-scale">
            <template #extension>
                <v-tabs v-model="currentItem" bg-color="primary">
                    <v-tab key="offen">
                        <v-icon left>fas fa-lock-open</v-icon>
                        {{ $t('open_gesuche') }}
                    </v-tab>
                    <v-tab key="geschlossen">
                        <v-icon left>fas fa-lock</v-icon>
                        {{ $t('closed_gesuche') }}
                    </v-tab>
                </v-tabs>
            </template>
            <template #controls>
                <v-btn
                    class="hidden-sm-and-up"
                    rounded="xl"
                    variant="flat"
                    color="subtleHint"
                    @click="checkProfile"
                    icon="fas fa-plus"
                >
                </v-btn>
                <v-btn
                    class="hidden-xs"
                    rounded="xl"
                    variant="flat"
                    color="subtleHint"
                    @click="checkProfile"
                    prepend-icon="fas fa-plus"
                >
                    {{ $t('create_gesuch') }}
                </v-btn>
            </template>
        </KpToolbar>
        <v-tabs-window v-model="currentItem">
            <v-tabs-window-item key="open">
                <v-container fluid>
                    <GesucheList status="open" />
                </v-container>
            </v-tabs-window-item>
            <v-tabs-window-item key="closed">
                <v-container fluid>
                    <GesucheList status="closed" />
                </v-container>
            </v-tabs-window-item>
        </v-tabs-window>
        <ProfileDialog
            v-model="showProfileDialog"
            @close="closeProfileDialog"
            @cancel="closeProfileDialog"
        />
    </div>
    <router-view v-else />
</template>
